import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllModelTypes } from "../api/getAllModelTypes";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useModelTypesDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetModelType []>([]);
  const getAllModelTypesQuery = useGetAllModelTypes({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllModelTypesQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllModelTypesQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllModelTypesQuery.data ? getAllModelTypesQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Είδος Συσκευής",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Είδους Συσκευής");
        break;
      case "edit":
        title = t("Επεξεργασία Είδους Συσκευής");
        break
        case "delete":
        title = t("Διαγραφή Είδους Συσκευής");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=> {
    setSelectedRowsOfTable([]);
    getAllModelTypesQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
